import React from 'react';
import externalLinkProps from './externalLinkProps';

/**
 * `.link-arr` — lien souligné suivi d'une flèche qui s'écarte au survol.
 *
 * Les deux appelants (`SectionHead`, `ExpertiseGrid`) le nourrissent
 * exclusivement avec des `href` issus d'un champ `cta_target` richfield —
 * jamais une ancre interne — d'où l'ouverture en nouvel onglet sur `href`
 * absolu (voir `externalLinkProps`).
 */
const LinkArrow = ({ href = '#', className = '', children, ...rest }) => (
  <a
    href={href}
    className={['link-arr', className].filter(Boolean).join(' ')}
    {...externalLinkProps(href)}
    {...rest}
  >
    {children} <span aria-hidden="true">→</span>
  </a>
);

export default LinkArrow;
